import { render, staticRenderFns } from "./FaqFormPage.vue?vue&type=template&id=3c279110&scoped=true"
import script from "./FaqFormPage.vue?vue&type=script&lang=js"
export * from "./FaqFormPage.vue?vue&type=script&lang=js"
import style0 from "./FaqFormPage.vue?vue&type=style&index=0&id=3c279110&prod&scoped=true&lang=css"
import style1 from "./FaqFormPage.vue?vue&type=style&index=1&id=3c279110&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c279110",
  null
  
)

export default component.exports